import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { T } from '@tolgee/react';

const StoreLocatorCTA = () => {
  return (
    <section className="relative overflow-hidden py-24 bg-[#111111]">
      {/* Fondo estático de mapa sin requerir load ni api key cliente */}
      <div className="absolute inset-0 opacity-20 bg-[url('/images/map_bg.png')] bg-cover bg-center pointer-events-none filter sepia-[.3] hue-rotate-[320deg] grayscale" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="w-20 h-20 mx-auto bg-yellow-400 rounded-full flex items-center justify-center mb-6 shadow-[0_0_40px_rgba(250,204,21,0.4)]">
              <MapPin className="text-black" size={40} fill="currentColor" />
            </div>
            
            <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200">
              <T keyName="home.store_locator.title">¿Buscas productos Jarad?</T>
            </h2>
            
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto">
              <T keyName="home.store_locator.subtitle">Encuentra tu distribuidor o tienda oficial más cercana en nuestro nuevo mapa interactivo. Tenemos puntos de venta especializados por zona.</T>
            </p>
            
            <Link
              to="/distribuidores"
              className="inline-flex items-center justify-center px-10 py-3 text-base font-bold rounded-full text-black bg-yellow-400 hover:bg-black hover:text-yellow-400 border-2 border-transparent hover:border-yellow-400 transition-colors shadow-none"
            >
              <T keyName="home.store_locator.button">Ver Mapa de Distribuidores</T>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StoreLocatorCTA; 
